import React from 'react';
import { FormControl, FormHelperText } from '@material-ui/core';
import { Select, Progress } from '@backstage/core-components';
import useBillingProductsPicker from './hooks';

export const BillingProductsPickerSchema = {
  uiOptions: {
    type: 'object',
    properties: {},
  },
  returnValue: { type: 'string' },
};

export const BillingProductsPicker = (props: any) => {
  const { onChange, schema, required, formData } = props;
  const { options, loading, error } = useBillingProductsPicker();

  if (loading) {
    return <Progress />;
  }

  if (error) {
    return (
      <FormControl margin="normal" error>
        <FormHelperText>Error loading products: {error}</FormHelperText>
      </FormControl>
    );
  }

  return (
    <FormControl
      margin="normal"
      required={required}
      error={required && !formData}
    >
      <Select
        label={schema.title || 'Billing Product'}
        placeholder="Select a product"
        items={options}
        onChange={onChange}
        selected={formData || ''}
      />
      {schema.description && (
        <FormHelperText>{schema.description}</FormHelperText>
      )}
    </FormControl>
  );
};